import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-294d479a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex items-center relative justify-center text-white",
  style: {"z-index":"9999"}
}
const _hoisted_2 = {
  id: "speech",
  class: "btn relative flex items-center justify-center bg-primary"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"30px !important","z-index":"999 !important","filter":"drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.5))"},
  class: "material-icons",
  "aria-hidden": "true"
}, " mic ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([
					_ctx.talking ? 'pulse-ring-anim' : 'pulse-ring-anim.stop',
					'pulse-ring mx-auto my-auto bg-transparent bg-primary border-primary',
				])
      }, null, 2),
      _hoisted_3
    ])
  ]))
}